import { useState } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faUserAlt,
  faUserCog,
  faHamburger,
} from "@fortawesome/free-solid-svg-icons";
import { analytics } from "../../analytics";
import { resetUserAccountDetails, setFirstLogin } from "../../redux/actions";
import accountManagement from "../../assets/accountManagement.png";
import strategyMarketplace from "../../assets/strategyMarketplace.png";
import firmSetup from "../../assets/firmSetup.png";
import dashboard from "../../assets/dashboard.png";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const BodyWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 200;
  width: ${(props) => (props.isCollapsed ? "80px" : "300px")};
  background-color: #004576;
  height: 105%;

  .collapsedSideBar {
    z-index: 200;
    width: 80px;
    background-color: #004576;
    height: 110vh;
    position: absolute;
    margin-top: -80px;
    .icon {
      color: white;
      font-size: 40px;
      text-align: center;
      margin-top: 150px;
      color: #48c8f4;
      cursor: pointer;
    }
  }

  .expandedSideBar {
    width: 300px;
    z-index: 201;
    background-color: #004576;
    height: 110vh;
    position: absolute;
    margin-top: -80px;
    padding: 0px 20px;

    .crossButtonContainer {
      width: 100%;
      text-align: right;
      color: #48c8f4;
      font-size: 40px;
      margin-top: 150px;
    }

    .linksContainer {
      margin-top: 50px;

      .sideBarLink {
        /* padding: 20px 20px; */
        height: 100px;
        width: 100%;
        cursor: pointer;
        font-size: 25px;
        background: transparent;
        border: none;
        color: white;
        display: flex;
        gap: 20px;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
        border-radius: 8px;
        margin-top: 20px;

        .sideBarIcon {
          color: #48c8f4;
          font-size: 40px;
          margin-right: 10px;
        }
      }

      .sideBarLink:hover {
        background: #00355b;
      }

      .sideBarLinkActive {
        background: #48c8f4;

        .sideBarIcon {
          color: white;
        }
      }
    }
    .logoutSection {
      margin-top: 10vh;
      text-align: center;
      color: white;
    }

    .logoutSection span {
      cursor: pointer;
    }
  }
`;

const AdvisorSideBar = (props) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const { userAccountDetails } = useSelector((state) => state.user);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleLogout = () => {
    analytics.track("Signed Out", {
      userId: userAccountDetails?.id || "",
    });
    cookies.remove("accessToken");
    dispatch(setFirstLogin(true));
    dispatch(resetUserAccountDetails());
    history.push("/advisor/login");
  };
  return (
    <BodyWrapper isCollapsed={isCollapsed}>
      <div className="collapsedSideBar">
        <div className="icon">
          <FontAwesomeIcon
            icon={faChevronRight}
            onClick={(e) => {
              setIsCollapsed(false);
            }}
          />
        </div>
      </div>
      {!isCollapsed && (
        <div className="expandedSideBar">
          <div className="crossButtonContainer">
            <span
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                setIsCollapsed(true);
              }}
            >
              X
            </span>
          </div>
          <div className="linksContainer">
            <button
              className={`sideBarLink ${
                props.activeSection == 1 && "sideBarLinkActive"
              }`}
              onClick={() => {
                history.push("/advisor-portal-landing");
              }}
            >
              <img src={dashboard} />
              Dashboard
            </button>
            <button
              className={`sideBarLink ${
                props.activeSection == 2 && "sideBarLinkActive"
              }`}
              onClick={() => {
                history.push("/advisor-portal-account-management");
              }}
              style={{ paddingLeft: "30px" }}
            >
              <img src={accountManagement} />
              <span style={{ textAlign: "left" }}>Account Management</span>
            </button>
            <button
              className={`sideBarLink ${
                props.activeSection == 4 && "sideBarLinkActive"
              }`}
              onClick={() => {
                history.push("/marketplace-dashboard");
              }}
              style={{ paddingLeft: "30px" }}
            >
              <img src={strategyMarketplace} />
              <span style={{ textAlign: "left" }}>Strategy Marketplace</span>
            </button>
            <button
              className={`sideBarLink ${
                props.activeSection == 3 && "sideBarLinkActive"
              }`}
              onClick={() => {
                history.push("/advisor-portal-users-under-my-farm");
              }}
            >
              <img src={firmSetup} />
              Firm Setup
            </button>
          </div>
          <div className="logoutSection">
            <span onClick={handleLogout}>Logout</span>
          </div>
        </div>
      )}
    </BodyWrapper>
  );
};

export default AdvisorSideBar;
